import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, RouteReuseStrategy } from '@angular/router';
import { RecreateOnParamChangeStrategy } from './routing/recreate-on-param-change.strategy';
import { routes } from './app.routes';
import { authConfig, MyStorageService } from './auth/auth.config';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { BrowserAnimationsModule, provideAnimations } from '@angular/platform-browser/animations';
import { ConfirmationService } from '@app/services/confirmation.service';
import { MessageService } from '@app/services/message.service';
import { AbstractLoggerService, authInterceptor, provideAuth } from 'angular-auth-oidc-client';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { AbstractSecurityStorage } from 'angular-auth-oidc-client';
import { ngrokSkipInterceptor } from './ngrok-skip.interceptor';
import { loadingInterceptor } from './loading.interceptor';
import { authHttpInterceptor } from './auth.interceptor';
import { MyCustomLogger } from './auth/my-custom-logger.service';
import { provideAuthInitializer } from './auth/auth-initializer.provider';
import { clientDiagnosticsInterceptor } from './interceptors/client-diagnostics.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    { provide: RouteReuseStrategy, useClass: RecreateOnParamChangeStrategy },
    provideAuth(authConfig),
    provideHttpClient(),
    provideAnimations(),
    { provide: AbstractSecurityStorage, useClass: MyStorageService },
    { provide: AbstractLoggerService, useClass: MyCustomLogger },
    provideAuthInitializer(),
    provideAnimationsAsync(),
    provideHttpClient(
      withInterceptors([
        authInterceptor(),
        ngrokSkipInterceptor,
        loadingInterceptor,
        authHttpInterceptor,
        clientDiagnosticsInterceptor,
      ]),
    ),
    MessageService,
    importProvidersFrom([BrowserAnimationsModule]),
    ConfirmationService,
  ],
};
